import React from "react";
import { CCard, CCardBody } from "@coreui/react";
import EmployerShell from "./EmployerShell";

export default function EmployerPageFrame({
  title,
  subtitle,
  actions = null,
  badge = "Experts4Europe Employer",
  contentClassName = "",
  shellProps = {},
  children,
}) {
  return (
    <EmployerShell title={title} subtitle={subtitle} badge={badge} actions={actions} {...shellProps}>
      <CCard className="admin-page-frame">
        <CCardBody className={`admin-page-frame__body ${contentClassName}`.trim()}>
          {children}
        </CCardBody>
      </CCard>
    </EmployerShell>
  );
}
